import axios from "axios";
import {businessAccountBaseUrl} from "../app.config"
import store from "../store/store";
import swal from "sweetalert";
import router from "../router";

const apiClient = axios.create({
    baseURL: businessAccountBaseUrl,
    withCredentials: false,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
    }
});
// https://cors-anywhere.herokuapp.com

apiClient.interceptors.request.use(config => {
    const token = store.getters.getToken;
    const tok = store.getters["auth/getTok"];
    config.headers.Authorization = (tok == null)? token: tok;
    return config
});

// eslint-disable-next-line no-unused-vars
apiClient.interceptors.response.use(config => {
    if (config != null)
        if (config.data != null)
            if (config.data.responseCode === '999' || config.data.responsecode === '999'){
                swal('Session Expired!',config.data.responsemessage != null?config.data.responsemessage:config.data.responseMessage,'info').then(res=>{
                    localStorage.clear();
                    console.log(res)
                    router.push('/').then()
                })
            }
    return config
});


export default {
    callReadWalletApi(payload) {
        // console.log("Service Payload ==>>", payload)
        return apiClient.post("walletRead", payload);
    },
    callGetWalletApi(payload) {
        // console.log("Service Payload ==>>", payload)
        return apiClient.post("getWallets", payload);
    },

    callReadWalletTransactionsApi(payload) {
        // console.log("Service Payload ==>>", payload)
        return apiClient.post("readWalletTransactions", payload);
    },

    callReadWalletAccountsApi(payload) {
        // console.log("Service Payload ==>>", payload)
        return apiClient.post("readWalletTransactions", payload);
    },

};
